import ExcelJS from 'exceljs';

export const styleHeader = (worksheet: ExcelJS.Worksheet, rowIndex: number, color: string = 'F6991D', isSubHeader: boolean = false) => {

    worksheet.getRow(rowIndex).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
    };

    worksheet.getRow(rowIndex).height = 35;

    worksheet.getRow(rowIndex).eachCell(function (cell) {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color }
        };
    });
    worksheet.getRow(rowIndex).font = {
        name: 'Arial',
        size: isSubHeader ? 8 : 12,  // Ukuran font lebih kecil untuk subHeader
        bold: !isSubHeader,  // Bold hanya untuk header utama
    };
};

export const createWorkbook = () => {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Looyal';
    workbook.lastModifiedBy = 'Looyal';
    workbook.created = new Date();
    workbook.modified = new Date();
    return workbook;
};

export const setColumnWidths = (worksheet: ExcelJS.Worksheet, source: string, fields: any, data: any) => {
    const colWidths = [30, 30, 20, 20, 20, 30, 30, 30, 30, 30, 30, 30, 30, 30, ...Object.keys(fields).map((field) => 25)];
    worksheet.columns = colWidths.map((width) => ({ width }));
};

export const createWorksheet = (workbook: ExcelJS.Workbook, source: string, sheetName: string = 'Sheet1') => {
    let worksheet;
    worksheet = workbook.addWorksheet(sheetName);
    return worksheet;
};

export const exportWorkbook = async (workbook: ExcelJS.Workbook, source: string, fileName: string) => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
    });
  };